/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { tap, map } from 'rxjs/operators';
import { XmlparseService } from '../xml/xmlparse.service';
import { Iceutility } from '../iceutility';
import { message } from '../../models/messages/message';
import { IceTypes } from '../../models/icetypes';

import { AlertService } from "../../services/alert/alert.service";
import { connectionparameters } from 'projects/icemedx-lib/src/models/messages/connectionparameters';
import { IceNavService } from 'projects/icemedx-lib/src/components/ice-nav/ice-nav.service';
import { LoginConfig } from 'projects/icemedx-lib/src/login/login.config';
import { LoginService } from '../../login/login.service';

declare var require: any;

@Injectable()
export class MessageService extends XmlparseService {

  constructor(private http: HttpClient, private alertSvc: AlertService, private loginSvc: LoginService) {
    super(alertSvc, loginSvc);
	}

  public getMessages(mbox?: IceTypes.MessageboxTypes, status?: IceTypes.trans_status): Observable<any> {
    if (mbox == null) mbox = IceTypes.MessageboxTypes.mboxINBOX;
    if (status == null) status = IceTypes.trans_status.isNone;

    let currentEnv: any = require("../../../../../env.json").currentEnv;
    let envs: any = require("../../../../../env.json").environments;
    if (!envs || !currentEnv) throw "Message service is not configured.";

    let url = envs[currentEnv].icemedx_api + "/members/default.aspx?domain=&data=messages&key=&subkeys=messagebox:" + mbox + ";status:" + (status == IceTypes.trans_status.isNone ? "" : status.toString()) + ";fromdate:;todate:" + ";blogonly:false";
		return this.http.get(url, { responseType: 'text' }).pipe(
			tap(
				data => this.parseLogReport(url, data),
				error => this.parseLogReport(url, error)
			)).map(response => this.parseMessages(response));
	}

  public sendMessage(message: message, navSvc: IceNavService): Observable<any> {
    try {
      let currentEnv: any = require("../../../../../env.json").currentEnv;
      let envs: any = require("../../../../../env.json").environments;
      if (!envs || !currentEnv) throw "Login service is not configured.";
      if (!Iceutility.isdefined(message)) throw "Invalid message.";

      if (message.SENDERS.length == 0)
        message.SENDERS.push(new connectionparameters());

      message.SENDERS[0].ip = location.origin;
      if (message.trans_type == IceTypes.TRANSTYPE.itDashboardPost)
        message.SENDERS[0].ip += LoginConfig.getFormattedPath("/wapp/", "dashboard");
      else if (message.trans_type == IceTypes.TRANSTYPE.itInvite)
        message.SENDERS[0].ip += LoginConfig.getFormattedPath("/wapp/", "messages/invitations");
      else
        message.SENDERS[0].ip += LoginConfig.getFormattedPath("/wapp/", "messages/inbox");

      let tblname = message.gettablename().toLowerCase();
      let data = "{" + JSON.stringify(tblname) + ": " + JSON.stringify(message) + "}";

      let url = envs[currentEnv].icemedx_api + "/members/default.aspx?domain=&data=sendmessage&key=&subkeys=messagebox:0;status:;";
      return this.http.post(url, data, { responseType: 'text' }).pipe(
        tap(
          data => this.parseLogReport(url, data),
          error => this.parseLogReport(url, error)
        )).map(response => this.parseMessage(response));
    } catch (e) {
      console.error(e.message);
    }
	}

  public updateMessage(message: message, navSvc: IceNavService): Observable<any> {
    try {
      let currentEnv: any = require("../../../../../env.json").currentEnv;
      let envs: any = require("../../../../../env.json").environments;
      if (!envs || !currentEnv) throw "Login service is not configured.";
      if (!Iceutility.isdefined(message)) throw "Invalid message.";

      let tblname = message.gettablename().toLowerCase();
      let data = "{" + JSON.stringify(tblname) + ": " + JSON.stringify(message) + "}";

      let url = envs[currentEnv].icemedx_api + "/members/default.aspx?domain=&data=updatemessage&key=&subkeys=messagebox:0;status:;";
      return this.http.post(url, data, { responseType: 'text' }).pipe(
        tap(
          data => this.parseLogReport(url, data),
          error => this.parseLogReport(url, error)
        )).map(response => this.parseMessage(response));
    } catch (e) {
      console.error(e.message);
    }
  }

  public deleteMessage(msg: message, mbox: IceTypes.MessageboxTypes, navSvc: IceNavService) {
    try {
      let currentEnv: any = require("../../../../../env.json").currentEnv;
      let envs: any = require("../../../../../env.json").environments;
      if (!envs || !currentEnv) throw "Login service is not configured.";
      if (!Iceutility.isdefined(msg)) throw "Invalid message key or box parameter.";

      let tblname = msg.gettablename().toLowerCase();
      let data = "{" + JSON.stringify(tblname) + ": " + JSON.stringify(msg) + "}";

      let url = envs[currentEnv].icemedx_api + "/members/default.aspx?domain=&data=deletemessage&key=" + msg.message_key + "&subkeys=messagebox:" + mbox + ";status:;";
      return this.http.post(url, data, { responseType: 'text' }).pipe(
        tap(
          data => this.parseLogReport(url, data),
          error => this.parseLogReport(url, error)
        )).map(response => this.parseMessage(response));
    } catch (e) {
      console.error(e.message);
    }
  }

  public updateBoardMessage(message: message, navSvc: IceNavService): Observable<any> {
    try {
      let currentEnv: any = require("../../../../../env.json").currentEnv;
      let envs: any = require("../../../../../env.json").environments;
      if (!envs || !currentEnv) throw "Login service is not configured.";
      if (!Iceutility.isdefined(message)) throw "Invalid message.";

      let tblname = message.gettablename().toLowerCase();
      let data = "{" + JSON.stringify(tblname) + ": " + JSON.stringify(message) + "}";

      let url = envs[currentEnv].icemedx_api + "/members/default.aspx?domain=&data=updateboardmessage&key=" + message.message_key + "&subkeys=messagebox:0;status:;";
      return this.http.post(url, data, { responseType: 'text' }).pipe(
        tap(
          data => this.parseLogReport(url, data),
          error => this.parseLogReport(url, error)
        )).map(response => this.parseMessage(response));
    } catch (e) {
      console.error(e.message);
    }
  }

  public changeMessageApproval(mkey: string, status: IceTypes.trans_status, mbox: IceTypes.MessageboxTypes, navSvc: IceNavService) {
    try {
      let currentEnv: any = require("../../../../../env.json").currentEnv;
      let envs: any = require("../../../../../env.json").environments;
      if (!envs || !currentEnv) throw "Login service is not configured.";
      if (!Iceutility.isdefined(mkey) || mkey.length == 0 || mbox.length == 0) throw "Invalid message key or box parameter.";

      let data = "{" + JSON.stringify(new message().gettablename()) + ": { " + "message_key: " + mkey + ", messagebox: " + mbox + "} }";

      let url = envs[currentEnv].icemedx_api + "/members/default.aspx?domain=&data=changemessageapproval&key=" + mkey + "&subkeys=messagebox:" + mbox + ";status:" + status.toString()  + ";";
      return this.http.post(url, data, { responseType: 'text' }).pipe(
        tap(
          data => this.parseLogReport(url, data),
          error => this.parseLogReport(url, error)
        )).map(response => this.parseMessage(response));
    } catch (e) {
      console.error(e.message);
    }
  }

  public addMessage(message: message, navSvc: IceNavService): Observable<any> {
    try {
      let currentEnv: any = require("../../../../../env.json").currentEnv;
      let envs: any = require("../../../../../env.json").environments;
      if (!envs || !currentEnv) throw "Login service is not configured.";
      if (!Iceutility.isdefined(message)) throw "Invalid message.";

      let tblname = message.gettablename().toLowerCase();
      let data = "{" + JSON.stringify(tblname) + ": " + JSON.stringify(message) + "}";

      let url = envs[currentEnv].icemedx_api + "/members/default.aspx?domain=&data=draftmessage&key=&subkeys=messagebox:0;status:;";
      return this.http.post(url, data, { responseType: 'text' }).pipe(
        tap(
          data => this.parseLogReport(url, data),
          error => this.parseLogReport(url, error)
        )).map(response => this.parseMessage(response));
    } catch (e) {
      console.error(e.message);
    }
  }

  public acceptInvite(message: message): Observable<any> {
    try {
      let currentEnv: any = require("../../../../../env.json").currentEnv;
      let envs: any = require("../../../../../env.json").environments;
      if (!envs || !currentEnv) throw "Login service is not configured.";
      if (!Iceutility.isdefined(message)) throw "Invalid message.";

      let tblname = message.gettablename().toLowerCase();
      let data = "{" + JSON.stringify(tblname) + ": " + JSON.stringify(message) + "}";

      let url = envs[currentEnv].icemedx_api + "/members/default.aspx?domain=&data=acceptinvite&key=" + message.message_key + "&subkeys=messagebox:0;status:;";
      return this.http.post(url, data, { responseType: 'text' }).pipe(
        tap(
          data => this.parseLogReport(url, data),
          error => this.parseLogReport(url, error)
        )).map(response => this.parseMessage(response));
    } catch (e) {
      console.error(e.message);
    }
  }

  public inviteRegister(message: message): Observable<any> {
    try {
      let currentEnv: any = require("../../../../../env.json").currentEnv;
      let envs: any = require("../../../../../env.json").environments;
      if (!envs || !currentEnv) throw "Login service is not configured.";
      if (!Iceutility.isdefined(message)) throw "Invalid message.";

      if (message.SENDERS.length == 0)
        message.SENDERS.push(new connectionparameters());

      message.SENDERS[0].ip = location.origin;
      message.SENDERS[0].ip += LoginConfig.getFormattedPath("/wapp/", "messages/invitations");

      let tblname = message.gettablename().toLowerCase();
      let data = "{" + JSON.stringify(tblname) + ": " + JSON.stringify(message) + "}";

      let url = envs[currentEnv].icemedx_api + "/members/default.aspx?domain=&data=inviteregister&key=" + message.message_key + "&subkeys=messagebox:0;status:;";
      return this.http.post(url, data, { responseType: 'text' }).pipe(
        tap(
          data => this.parseLogReport(url, data),
          error => this.parseLogReport(url, error)
        )).map(response => this.parseMessage(response));
    } catch (e) {
      console.error(e.message);
    }
  }
  public declineInvite(message: message): Observable<any> {
    try {
      let currentEnv: any = require("../../../../../env.json").currentEnv;
      let envs: any = require("../../../../../env.json").environments;
      if (!envs || !currentEnv) throw "Login service is not configured.";
      if (!Iceutility.isdefined(message)) throw "Invalid message.";

      let tblname = message.gettablename().toLowerCase();
      let data = "{" + JSON.stringify(tblname) + ": " + JSON.stringify(message) + "}";

      let url = envs[currentEnv].icemedx_api + "/members/default.aspx?domain=&data=declineinvite&key=" + message.message_key + "&subkeys=messagebox:0;status:;";
      return this.http.post(url, data, { responseType: 'text' }).pipe(
        tap(
          data => this.parseLogReport(url, data),
          error => this.parseLogReport(url, error)
        )).map(response => this.parseMessage(response));
    } catch (e) {
      console.error(e.message);
    }
  }

  public tentativeInvite(message: message): Observable<any> {
    try {
      let currentEnv: any = require("../../../../../env.json").currentEnv;
      let envs: any = require("../../../../../env.json").environments;
      if (!envs || !currentEnv) throw "Login service is not configured.";
      if (!Iceutility.isdefined(message)) throw "Invalid message.";

      let tblname = message.gettablename().toLowerCase();
      let data = "{" + JSON.stringify(tblname) + ": " + JSON.stringify(message) + "}";

      let url = envs[currentEnv].icemedx_api + "/members/default.aspx?domain=&data=tentativeinvite&key=" + message.message_key + "&subkeys=messagebox:0;status:;";
      return this.http.post(url, data, { responseType: 'text' }).pipe(
        tap(
          data => this.parseLogReport(url, data),
          error => this.parseLogReport(url, error)
        )).map(response => this.parseMessage(response));
    } catch (e) {
      console.error(e.message);
    }
  }

  public getMessage(key: string, byparentkey: boolean = false): Observable<any> {
    let currentEnv: any = require("../../../../../env.json").currentEnv;
    let envs: any = require("../../../../../env.json").environments;
	  if (!envs || !currentEnv) throw "Login service is not configured.";

    let url = envs[currentEnv].icemedx_api + "/members/default.aspx?domain=&data=messagedetail&key=" + key + "&subkeys=byparentkey:" + byparentkey.toString();
    return this.http.get(url, { responseType: 'text' }).pipe(
      tap(
        data => this.parseLogReport(url, data),
        error => this.parseLogReport(url, error)
		)).map(response => this.parseMessage(response));
  }

  public getMessageFileUploadUri(domain: string, domaintype: IceTypes.ACCOUNT_TYPE, msgkey: string, extkey: string, srctype: IceTypes.SourceType): string {
    try {
      let currentEnv: any = require("../../../../../env.json").currentEnv;
      let envs: any = require("../../../../../env.json").environments;
      if (!envs || !currentEnv) throw "Login service is not configured.";
      let url = envs[currentEnv].icemedx_api + "/members/default.aspx?domain=" + domain + "&data=messagefile&acttype=" + domaintype.toString() + "&key=" + msgkey + "&subkeys=extkey:" + extkey + ";src_type:" + srctype.toString() + ";original_path:unknown.file";
      return url;
    } catch (e) {
      console.error(e.message);
    }
    return "";
  }

  public getMessageAttachment(msgkey: string, extkey: string, srctype: IceTypes.SourceType): Observable<any> {
    let currentEnv: any = require("../../../../../env.json").currentEnv;
    let envs: any = require("../../../../../env.json").environments;
    if (!envs || !currentEnv) throw "Login service is not configured.";

    let url = envs[currentEnv].icemedx_api + "/members/default.aspx?domain=&data=messagefileattachment&domaintype=&patientdomain=" + "&key=" + msgkey + "&subkeys=extkey:" + extkey + ";srctype:" + srctype.toString();
    return this.http.get(url, { responseType: 'text' }).pipe(
      tap(
        data => this.parseLogReport(url, data),
        error => this.parseLogReport(url, error)
      )).map(response => response);
  }

  public loadMessageFile(key: string, extkey: string, srctype: IceTypes.SourceType, fileName: string = "Untitlted", fileDownloadResponseCallback) {
    let currentEnv: any = require("../../../../../env.json").currentEnv;
    let envs: any = require("../../../../../env.json").environments;
    if (!envs || !currentEnv) throw "Message service is not configured.";

    try {
      let url = envs[currentEnv].icemedx_api + "/members/default.aspx?domain=&data=messagefileattachment&domaintype=&patientdomain=" + "&key=" + key + "&subkeys=extkey:" + extkey + ";srctype:" + srctype.toString();
      var req = new XMLHttpRequest();

      req.open("GET", url, true);
      req.responseType = "blob";

      let userInfo = this.loginSvc.GetSessionUserInfo();
      var token = this.loginSvc.GetAccessToken(userInfo);
      if (token != null) {
        req.setRequestHeader("Authorization", 'Bearer ' + token);

        req.onload = (event) => {
          var blob = req.response;
          var newBlob = new Blob([blob], { type: blob.type });
          this.downloadBlob(fileName, newBlob);
          fileDownloadResponseCallback();
        };
        req.onreadystatechange = function (oEvent) {
          if (req.readyState === 4) {
            if (req.status != 200) {
              console.log(req.statusText);
              fileDownloadResponseCallback();
            }
          }
        };

        req.send();
      }
    }
    catch (e) {
      console.log(e.message);
      fileDownloadResponseCallback();
    }
  }

  private downloadBlob(fileName, blob) {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.target = '_blank';
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
  }

  public removeMessageAttachment(domain: string, domaintype: IceTypes.ACCOUNT_TYPE, msgkey: string, srctype: IceTypes.SourceType, extkey: string): Observable<any> {
    let currentEnv: any = require("../../../../../env.json").currentEnv;
    let envs: any = require("../../../../../env.json").environments;
    if (!envs || !currentEnv) throw "Login service is not configured.";
    let url = envs[currentEnv].icemedx_api + "/members/default.aspx?domain=" + domain + "&data=removemessageattachment&acttype=" + domaintype.toString() + "&key=" + msgkey + "&subkeys=extkey:" + extkey + ";srctype:" + srctype.toString();
    let data = "{}";
    return this.http.post(url, data, { responseType: 'text' }).pipe(
      tap(
        data => this.parseLogReport(url, data),
        error => this.parseLogReport(url, error)
      )).map(response => this.parseMessage(response));
  }

  public insertMessageAttachment(key: string, docdata, currentAccount, accountType) {
    try {
      let currentEnv: any = require("../../../../../env.json").currentEnv;
      let envs: any = require("../../../../../env.json").environments;
      if (!envs || !currentEnv) throw "Login service is not configured.";
      let url = this.getMessageFileUploadUri(currentAccount, accountType, key, "", IceTypes.SourceType.srcMiscellaneousForms);
      var fd = new FormData();
      fd.append('icefile', docdata);

      return this.http.post(url, fd, { responseType: 'text' }).pipe(
        tap(
          data => this.parseLogReport(url, data),
          error => this.parseLogReport(url, error)
        )).map(response => this.geticexdocumentobjects(response, ["EXTERNAL_DATA"]));
    } catch (e) {
      console.log(e.message);
    }  
}

	private parseMessages(prvData: any) {
		let results = super.geticexdocumentobjects(prvData, ["MESSAGE_REFERENCE"]);
		if (results) {
			results = results.map(pro => { return pro; });
		}
		return results;
	}

	private parseMessage(response: any) {
		let results = super.geticexdocumentobjects(response, ["MESSAGE"]);
		if (results) {
			results = results.map(pro => { return pro; });
		}
		return results;
  }

  public isMemberOnMessage(msg: message, memid: string): boolean {
    if (msg == null) return false;

    let tempmemid = memid.toLowerCase();   
    return msg.to.toLowerCase().indexOf(tempmemid) >= 0
      || msg.cc.toLowerCase().indexOf(tempmemid) >= 0
      || msg.bcc.toLowerCase().indexOf(tempmemid) >= 0;
  }

  static getStatus(ts: IceTypes.trans_status, srcType?: IceTypes.SourceType): string  {
    switch (ts) {
      case IceTypes.trans_status.isError:
        return "Error";
      case IceTypes.trans_status.isNone: {
        if (srcType != null && srcType == IceTypes.SourceType.srcStatement)
          return "Editing";

        return "None";
      }
      case IceTypes.trans_status.isReadyToSend:
        return "Ready";
      case IceTypes.trans_status.isReadyToPrint:
        return "Ready-To-Print";
      case IceTypes.trans_status.isSent:
        return "Sent";
      case IceTypes.trans_status.isReceived:
        return "Received";
      case IceTypes.trans_status.isTimeout:
        return "Timeout";
      case IceTypes.trans_status.isVoided:
        return "Voided";
      case IceTypes.trans_status.isReSent:
        return "Re-Sent";
      case IceTypes.trans_status.isPrinted:
        return "Printed";
      case IceTypes.trans_status.isDenied:
        return "Denied";
      case IceTypes.trans_status.isPending:
        return "Pending";
      case IceTypes.trans_status.isVerified:
        return "Verified";
      case IceTypes.trans_status.isPaid:
        return "Paid";
      case IceTypes.trans_status.isModified:
        return "Modified";
      case IceTypes.trans_status.isRejected:
        return "Rejected";
      case IceTypes.trans_status.isAccepted:
        return "Accepted";
      case IceTypes.trans_status.isPaymentReceived:
        return "PaymentReceived";
      case IceTypes.trans_status.isApproved:
        return "Approved";
      case IceTypes.trans_status.isRead:
        return "Read";
      case IceTypes.trans_status.isUnRead:
        return "UnRead";
    }
    return "Unknown";
  }

  static getAccountItemStatues(): any[] {
    return [
      { value: IceTypes.trans_status.isAccepted, name: MessageService.getStatus(IceTypes.trans_status.isAccepted) },
      { value: IceTypes.trans_status.isApproved, name: MessageService.getStatus(IceTypes.trans_status.isApproved) },
      { value: IceTypes.trans_status.isDenied, name: MessageService.getStatus(IceTypes.trans_status.isDenied) },
      { value: IceTypes.trans_status.isError, name: MessageService.getStatus(IceTypes.trans_status.isError) },
      { value: IceTypes.trans_status.isNone, name: MessageService.getStatus(IceTypes.trans_status.isNone, IceTypes.SourceType.srcStatement) },
      { value: IceTypes.trans_status.isPaid, name: MessageService.getStatus(IceTypes.trans_status.isPaid) },
      { value: IceTypes.trans_status.isPending, name: MessageService.getStatus(IceTypes.trans_status.isPending) },
      { value: IceTypes.trans_status.isPrinted, name: MessageService.getStatus(IceTypes.trans_status.isPrinted) },
      { value: IceTypes.trans_status.isReadyToSend, name: MessageService.getStatus(IceTypes.trans_status.isReadyToSend) },
      { value: IceTypes.trans_status.isReadyToPrint, name: MessageService.getStatus(IceTypes.trans_status.isReadyToPrint) },
      { value: IceTypes.trans_status.isRejected, name: MessageService.getStatus(IceTypes.trans_status.isRejected) },
    ];
  }
  public static getTransTypes(): any[] {
    let list = [
      { value: IceTypes.TRANSTYPE.itClaimSubmission, name: "Claim Submission" },
      { value: IceTypes.TRANSTYPE.itCreditCard, name: "Credit Card Gateway" },
      { value: IceTypes.TRANSTYPE.itEligibility, name: "Eligibility" },
      { value: IceTypes.TRANSTYPE.iteMedicationHistory, name: "Medication History" },
      { value: IceTypes.TRANSTYPE.itePrescriptionRouting, name: "e-Prescribing" },
      { value: IceTypes.TRANSTYPE.iteFormularyBenefitRequest, name: "Formulary" },
      { value: IceTypes.TRANSTYPE.itHL7, name: "Health Information Exchange" },
      { value: IceTypes.TRANSTYPE.itNone, name: "Synchronized Record Access" }
    ];
    list.sort(function (a, b) { return a.name.localeCompare(b.name) });
    return list;
  }

  static getTransTypeDesc(type: IceTypes.TRANSTYPE): string {
    let typs = this.getTransTypes().filter(t => t.value == type);
    return typs.length > 0 ? typs[0].name : "Unknown";
  }

  static getTransTypeValueFromDesc(desc: string): IceTypes.TRANSTYPE {
    let typs = this.getTransTypes().filter(t => t.name.toLowerCase() == desc.toLowerCase());
    return typs.length > 0 ? <IceTypes.TRANSTYPE>typs[0].value : IceTypes.TRANSTYPE.itNone;
  }

  static getTransTypeText(typ: IceTypes.TRANSTYPE): string {
    let text: string = "None";
    switch (typ) {
      case IceTypes.TRANSTYPE.itEligibility:
        {
          text = "Eligibility";
          break;
        }
      case IceTypes.TRANSTYPE.itEligibilityResponse:
        {
          text = "Eligibility Response";
          break;
        }
      case IceTypes.TRANSTYPE.itClaimSubmission:
        {
          text = "Claim";
          break;
        }
      case IceTypes.TRANSTYPE.itClaimSubmissionResponse:
        {
          text = "Claim Response";
          break;
        }
      case IceTypes.TRANSTYPE.itEFT:
        {
          text = "Electronic Transfer";
          break;
        }
      case IceTypes.TRANSTYPE.itEFTResponse:
        {
          text = "Electronic Transfer Response";
          break;
        }
      case IceTypes.TRANSTYPE.itPreCertReferral:
        {
          text = "Pre. Cert. Referral";
          break;
        }
      case IceTypes.TRANSTYPE.itPreCertReferralResponse:
        {
          text = "Pre. Cert. Referral Response";
          break;
        }
      case IceTypes.TRANSTYPE.itClaimInquiry:
        {
          text = "Claim Inquiry";
          break;
        }
      case IceTypes.TRANSTYPE.itClaimInquiryResponse:
        {
          text = "Claim Inquiry Response";
          break;
        }
      case IceTypes.TRANSTYPE.itePrescribe:
        {
          text = "e-Prescribe";
          break;
        }
      case IceTypes.TRANSTYPE.itePrescribeResponse:
        {
          text = "e-Prescribe Response";
          break;
        }
      case IceTypes.TRANSTYPE.itCreditCard:
        {
          text = "Credit Card";
          break;
        }
      case IceTypes.TRANSTYPE.itCreditCardResponse:
        {
          text = "Credit Card Response";
          break;
        }
      case IceTypes.TRANSTYPE.itHL7:
        {
          text = "HL7";
          break;
        }
      case IceTypes.TRANSTYPE.itHL7Response:
        {
          text = "HL7 Response";
          break;
        }
      case IceTypes.TRANSTYPE.itPrintClaim:
        {
          text = "Print Claim";
          break;
        }
      case IceTypes.TRANSTYPE.itPrintClaimResponse:
        {
          text = "Print Claim Response";
          break;
        }
      case IceTypes.TRANSTYPE.itERAResponse:
        {
          text = "ERA Response";
          break;
        }
      case IceTypes.TRANSTYPE.itPayPal:
        {
          text = "PayPal";
          break;
        }
      case IceTypes.TRANSTYPE.itPayPalResponse:
        {
          text = "PayPal Response";
          break;
        }
      case IceTypes.TRANSTYPE.itPatientStatement:
        {
          text = "Patient Statement";
          break;
        }
      case IceTypes.TRANSTYPE.itPatientStatementResponse:
        {
          text = "Patient Statement Response";
          break;
        }
      case IceTypes.TRANSTYPE.itPaperCheck:
        {
          text = "Paper Check";
          break;
        }
      case IceTypes.TRANSTYPE.itInvite:
        {
          text = "Invite";
          break;
        }
      case IceTypes.TRANSTYPE.itDashboardPost:
        {
          text = "Dashboard Post";
          break;
        }
      case IceTypes.TRANSTYPE.iteOrganizationDownload:
        {
          text = "Organization Download";
          break;
        }
      case IceTypes.TRANSTYPE.iteOrganizationDownloadResponse:
        {
          text = "Organization Download Response";
          break;
        }
      case IceTypes.TRANSTYPE.itePrescriptionRouting:
        {
          text = "Prescription Routing";
          break;
        }
      case IceTypes.TRANSTYPE.itePrescriptionRoutingResponse:
        {
          text = "Prescription Routing Response";
          break;
        }
      case IceTypes.TRANSTYPE.iteMedicationHistory:
        {
          text = "Medication History";
          break;
        }
      case IceTypes.TRANSTYPE.iteMedicationHistoryResponse:
        {
          text = "Medication History Response";
          break;
        }
      case IceTypes.TRANSTYPE.iteLab:
        {
          text = "Lab";
          break;
        }
      case IceTypes.TRANSTYPE.iteLabResponse:
        {
          text = "Lab Response";
          break;
        }
      case IceTypes.TRANSTYPE.itSurvey:
        {
          text = "Survey";
          break;
        }
      case IceTypes.TRANSTYPE.itSurveyResponse:
        {
          text = "Survey Response";
          break;
        }
      case IceTypes.TRANSTYPE.itAlarm:
        {
          text = "Alarm";
          break;
        }
      case IceTypes.TRANSTYPE.itAlarmResponse:
        {
          text = "Alarm Response";
          break;
        }
      case IceTypes.TRANSTYPE.iteDirectoryDownload:
        {
          text = "Directory Download";
          break;
        }
      case IceTypes.TRANSTYPE.iteDirectoryDownloadResponse:
        {
          text = "Directory Download Response";
          break;
        }
      case IceTypes.TRANSTYPE.iteAddUpdateProviderLocation:
        {
          text = "Add Update Provider Location";
          break;
        }
      case IceTypes.TRANSTYPE.iteAddUpdateProviderLocationResponse:
        {
          text = "Add Update Provider Location Response";
          break;
        }
      case IceTypes.TRANSTYPE.iteGetProviderLocation:
        {
          text = "Get Provider Location";
          break;
        }
      case IceTypes.TRANSTYPE.iteGetProviderLocationResponse:
        {
          text = "Get Provider Location Response";
          break;
        }
      case IceTypes.TRANSTYPE.iteDisableProviderLocation:
        {
          text = "Disable Provider Location";
          break;
        }
      case IceTypes.TRANSTYPE.iteDisableProviderLocationResponse:
        {
          text = "Disable Provider Location Response";
          break;
        }
    }
    return text;
  }

  public static getParticipatingTypes(): any[] {
    let list = [
      { value: IceTypes.participation_type.pptNonParticipating, name: "Non-Participating" },
      { value: IceTypes.participation_type.pptParticipating, name: "Participating" },
      { value: IceTypes.participation_type.pptParticipatingPlus, name: "ParticipatingPlus" },
    ];
    list.sort(function (a, b) { return a.name.localeCompare(b.name) });
    return list;
  }

  static getParticipatingTypeDesc(type: IceTypes.participation_type): string {
    let typs = this.getParticipatingTypes().filter(t => t.value == type);
    return typs.length > 0 ? typs[0].name : "Unknown";
  }

  static getParticipatingTypeValueFromDesc(desc: string): IceTypes.participation_type {
    let typs = this.getParticipatingTypes().filter(t => t.name.toLowerCase() == desc.toLowerCase());
    return typs.length > 0 ? <IceTypes.participation_type>typs[0].value : IceTypes.participation_type.pptNonParticipating;
  }

  public static getConnectionTypes(): any[] {
    let list = [
      { value: IceTypes.CONNECTIONTYPE.conntypNone, name: "None" },
      { value: IceTypes.CONNECTIONTYPE.conntypBatchMode, name: "Batch-Mode" },
      { value: IceTypes.CONNECTIONTYPE.conntypRealtime, name: "Real-time" },
      { value: IceTypes.CONNECTIONTYPE.conntypGatewayUI, name: "GatewayUI" },
    ];
    list.sort(function (a, b) { return a.name.localeCompare(b.name) });
    return list;
  }

  static getConnectionTypeDesc(type: IceTypes.CONNECTIONTYPE): string {
    let typs = this.getConnectionTypes().filter(t => t.value == type);
    return typs.length > 0 ? typs[0].name : "Unknown";
  }

  static getConnectionTypeValueFromDesc(desc: string): IceTypes.CONNECTIONTYPE {
    let typs = this.getConnectionTypes().filter(t => t.name.toLowerCase() == desc.toLowerCase());
    return typs.length > 0 ? <IceTypes.CONNECTIONTYPE>typs[0].value : IceTypes.CONNECTIONTYPE.conntypNone;
  }

  public static getProtocols(): any[] {
    let list = [
      { value: IceTypes.PROTOCOL.protocolNone, name: "None" },
      { value: IceTypes.PROTOCOL.protocolSFTP, name: "SFTP" },
      { value: IceTypes.PROTOCOL.protocolFTPS, name: "FTPS" },
      { value: IceTypes.PROTOCOL.protocolFTP, name: "FTP" },
      { value: IceTypes.PROTOCOL.protocolHTTPS, name: "HTTPS" },
    ];
    list.sort(function (a, b) { return a.name.localeCompare(b.name) });
    return list;
  }

  static getProtocolDesc(type: IceTypes.PROTOCOL): string {
    let typs = this.getProtocols().filter(t => t.value == type);
    return typs.length > 0 ? typs[0].name : "Unknown";
  }

  static getProtocolValueFromDesc(desc: string): IceTypes.PROTOCOL {
    let typs = this.getProtocols().filter(t => t.name.toLowerCase() == desc.toLowerCase());
    return typs.length > 0 ? <IceTypes.PROTOCOL>typs[0].value : IceTypes.PROTOCOL.protocolNone;
  }

  public static getProtocolAPIs(): any[] {
    let list = [
      { value: IceTypes.PROTOCOLAPI.papiURL, name: "URL" },
      { value: IceTypes.PROTOCOLAPI.papiPutty, name: "Putty" },
      { value: IceTypes.PROTOCOLAPI.papiMoveitFreely, name: "MoveitFreely" },
    ];
    list.sort(function (a, b) { return a.name.localeCompare(b.name) });
    return list;
  }

  static getProtocolAPIDesc(type: IceTypes.PROTOCOLAPI): string {
    let typs = this.getProtocolAPIs().filter(t => t.value == type);
    return typs.length > 0 ? typs[0].name : "Unknown";
  }

  static getProtocolAPIValueFromDesc(desc: string): IceTypes.PROTOCOLAPI {
    let typs = this.getProtocolAPIs().filter(t => t.name.toLowerCase() == desc.toLowerCase());
    return typs.length > 0 ? <IceTypes.PROTOCOLAPI>typs[0].value : IceTypes.PROTOCOLAPI.papiURL;
  }

  public static getDataTransportFormats(): any[] {
    let list = [
      { value: IceTypes.DATA_TRANSPORT_FORMAT.datatfmtNone, name: "None" },
      { value: IceTypes.DATA_TRANSPORT_FORMAT.datatfmtXML, name: "XML" },
      { value: IceTypes.DATA_TRANSPORT_FORMAT.datatfmtHL7, name: "HL7" },
      { value: IceTypes.DATA_TRANSPORT_FORMAT.datatfmtX12N, name: "X12N" },
      { value: IceTypes.DATA_TRANSPORT_FORMAT.datatfmtMultipartMIME, name: "Multipart-MIME" },
      { value: IceTypes.DATA_TRANSPORT_FORMAT.datatfmtJson, name: "JSON" },
    ];
    list.sort(function (a, b) { return a.name.localeCompare(b.name) });
    return list;
  }

  static getDataTransportFormatDesc(type: IceTypes.DATA_TRANSPORT_FORMAT): string {
    let typs = this.getDataTransportFormats().filter(t => t.value == type);
    return typs.length > 0 ? typs[0].name : "Unknown";
  }

  static getDataTransportFormatValueFromDesc(desc: string): IceTypes.DATA_TRANSPORT_FORMAT {
    let typs = this.getDataTransportFormats().filter(t => t.name.toLowerCase() == desc.toLowerCase());
    return typs.length > 0 ? <IceTypes.DATA_TRANSPORT_FORMAT>typs[0].value : IceTypes.DATA_TRANSPORT_FORMAT.datatfmtNone;
  }

  static statusToText(ts: IceTypes.trans_status): string {
    let text: string = "";
    try {
      text = ts.toString();
    }
    catch
    {
      text = "";
    }
    return text;
  }

  static textToStatus(text: string): IceTypes.trans_status {
    let ret: IceTypes.trans_status = IceTypes.trans_status.isNone;
    if (text == null || text.length == 0)
      return ret;

    try {
      ret = <IceTypes.trans_status>Iceutility.toLong(text);
    }
    catch
    {
      ret = IceTypes.trans_status.isNone;
    }
    return ret;
  }

}
